import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ChevronRightIcon from '@mui/icons-material/ChevronRightRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import './LiveInsight.scss';

const insights = [
  'Blood sugar trending within range',
  'Great progress on your health goals',
  'Your health is steadily improving',
  'Vitamin D levels looking better',
];

export default function LiveInsight() {
  const [isVisible, setIsVisible] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % insights.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      className="live-insight"
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ delay: 1, duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <div className="live-insight__icon">
        <AutoAwesomeIcon />
      </div>
      <div className="live-insight__content">
        <div className="live-insight__label">
          Live Insight
          <span className="live-insight__pulse" />
        </div>
        <AnimatePresence mode="wait">
          <motion.p
            key={currentIndex}
            className="live-insight__text"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3 }}
          >
            {insights[currentIndex]}
          </motion.p>
        </AnimatePresence>
      </div>
      <div className="live-insight__actions">
        <button
          className="live-insight__nav"
          onClick={() => setCurrentIndex((prev) => (prev + 1) % insights.length)}
          aria-label="Next insight"
        >
          <ChevronRightIcon />
        </button>
        <button
          className="live-insight__close"
          onClick={() => setIsVisible(false)}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
      <div className="live-insight__dots">
        {insights.map((_, i) => (
          <span
            key={i}
            className={`live-insight__dot ${i === currentIndex ? 'live-insight__dot--active' : ''}`}
          />
        ))}
      </div>
    </motion.div>
  );
}
